import React, { useState, useEffect, useMemo } from 'react';
import { calculateTimeRemaining, makeString } from '../utils/timer'

const Timer = ({ endDate }) => {
  const [timeRemaining, setTimeRemaining] = useState(calculateTimeRemaining(endDate));

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setTimeRemaining(calculateTimeRemaining(endDate));
    }, 1000);

    // if (timeRemaining.days === 0 && timeRemaining.hours === 0 && timeRemaining.minutes === 0 && timeRemaining.seconds === 0) {
    //   clearInterval(timerInterval);
    // }

    // return () => {
    //   clearInterval(timerInterval)
    // };
  }, [endDate]);

  const content = useMemo(() => {
    return makeString(timeRemaining);
  }, [timeRemaining]);


  return content;
};

export default Timer;
